import { createContext, useState, useContext } from "react";

const CartContext = createContext();

const getInitialCart = () => {
  try {
    const stored = localStorage.getItem("cart");
    return stored ? JSON.parse(stored) : [];
  } catch (e) {
    console.error("Invalid cart data in localStorage:", e);
    localStorage.removeItem("cart"); // Xóa dữ liệu hỏng
    return [];
  }
};

export function CartProvider({ children }) {
  const [cart, setCart] = useState(getInitialCart);

  function addToCart(product) {
    const existing = cart.find((p) => p.id === product.id);
    let newCart;
    if (existing) {
      newCart = cart.map((p) =>
        p.id === product.id ? { ...p, quantity: p.quantity + 1 } : p
      );
    } else {
      newCart = [...cart, { ...product, quantity: 1 }];
    }
    setCart(newCart);
    localStorage.setItem("cart", JSON.stringify(newCart));
  }

  function removeFromCart(productId) {
    const newCart = cart.filter((p) => p.id !== productId);
    setCart(newCart);
    localStorage.setItem("cart", JSON.stringify(newCart));
  }

  return (
    <CartContext.Provider value={{ cart, setCart, addToCart, removeFromCart }}>
      {children}
    </CartContext.Provider>
  );
}
export function useCart() { return useContext(CartContext); }